import useFormat from '../../hooks/useFormat';

const useWidgetLogoSize = () => {
	const { isMobileFormat } = useFormat();

	return { logoSize: isMobileFormat ? 54 : 86 };
};

export default useWidgetLogoSize;
